module.exports = __webpack_public_path__ + "img/loading-dark.f0269d33.svg";